import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function H() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    const POSTER_MAP: any = {
        eu: '_eu',
        de: '',
        it: '_it',
        es: '_es',
    };
    const lists: any = [
        {
            img: '/responsive/picture/power-independence/8_1',
            desc: t('secH_card1_text'),
            video: {
                de: 'https://www.youtube.com/embed/6ACGCkWT9zc?si=2vxw5EYl5uFWySP5',
                fr: '',
                eu: 'https://www.youtube.com/embed/OwDJ8G1ogD8?si=WERKzBBkCgs4UdWy',
                uk: '',
                it: 'https://www.youtube.com/embed/Ck3eTHaPJJY?si=7KfcxShN6zb9T5SV',
                es: 'https://www.youtube.com/embed/BXN7BNEgA3A?si=V0Tv_VV4t5PPFucs',
            },
        },
        {
            img: '/responsive/picture/power-independence/8_2',
            desc: t('secH_card2_text'),
            video: {
                de: 'https://www.youtube.com/embed/i3vw_Zh8gt8?si=KlVX-xa5oNWa0lMB',
                fr: '',
                eu: 'https://www.youtube.com/embed/i3vw_Zh8gt8?si=0AuHcMwQct5x-ref',
                uk: '',
                it: 'https://www.youtube.com/embed/gGAy1XWH_RM?si=v7F6-oxmk37iDMNv',
                es: 'https://www.youtube.com/embed/XyVpCmaVwYE?si=wJWWW4kQ4kSEAqSK',
            },
        },
        {
            img: '/responsive/picture/power-independence/8_3',
            desc: t('secH_card3_text'),
            video: {
                de: 'https://www.youtube.com/embed/0M4CGxyZfzA?si=id2gUkAJXCfOQTTs',
                fr: '',
                eu: 'https://www.youtube.com/embed/JFHxWgQXDnY?si=SOZUd9FRnsC-qnnq',
                uk: '',
                it: 'https://www.youtube.com/embed/YgNfH0QkKZE?si=beqQkOpMO_cfWwWG',
                es: 'https://www.youtube.com/embed/_50522RCbzI?si=S_5oCuTFl4JQUt0Z',
            },
        },
        {
            img: '/responsive/picture/power-independence/8_4',
            desc: t('secH_card4_text'),
            video: {
                de: 'https://www.youtube.com/embed/Ifx7fsTqzis?si=0KlRmTQmbpaS07wn',
                fr: '',
                eu: 'https://www.youtube.com/embed/LM3PKaRYFAU?si=0VUYjqtvn5uEQEl7',
                uk: '',
                it: 'https://www.youtube.com/embed/k7nh_PeWQC8?si=3GZl40UFTm2Ebbxh',
                es: 'https://www.youtube.com/embed/WVKDQzGqwwc?si=8RKqoUvhVswghRvB',
            },
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="power-independence-H" className={`power-independence-H ${css['power-independence-H']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secH_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video[locale])}>
                            <EFPicture
                                src={`${card?.img}${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                srcPad={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                srcMobile={`${card?.img}_375${POSTER_MAP[locale] || POSTER_MAP.de}.jpg`}
                                alt={card?.desc}
                            />
                            <YoutubePlay className="youtube-icon" />
                            <p className="card-text">{card?.desc}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
